module.exports = __webpack_public_path__ + "static/media/up-arrow-icon.36e3b745.png";